/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { format, parseISO } from 'date-fns';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { HiCheck, HiPlus } from 'react-icons/hi';
import { AxiosError } from 'axios';
import { TableList, Container, Filter, Status, Modal } from './styles';

import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import Table, { IColumn } from '~/components/Table';
import FiltersLists from '~/components/FiltersLists';
import { formatPrice } from '~/utils/format';
import { KrClose, KrEye } from '~/components/KoroIcons';
import Input from '~/components/Input';
import Loading from '~/components/Loading';
import InputMask from '~/components/InputMask';
import Toast from '~/utils/toast';

interface ITicket {
  id: number;
  item_id: number;
  batchCategory_id: number;
  number: string;
  value: number;
  name: string;
  document: string;
  modality: string;
  category: string;
  isChecked: boolean;
  canceled: boolean;
  discount: number;
}

interface ICancellation {
  id?: number;
  event_id?: number;
  payment_id?: number;
  order_id?: number;
  user_id?: number;
  request_id?: string;
  request_date?: string;
  order_date?: string;
  request_type?: string;
  event: string;
  buyer_name: string;
  buyer_cpf: string;
  buy_date: string;
  order_number: string;
  ticket_quantity: string;
  order_value: string;
  cancel_quantity?: string;
  cancel_value?: string;
  payment_status?: string;
  execution_date?: string;
  tax_value?: string;
  file?: string;
  file_name?: string;
  tickets: ITicket[];
}

interface IItem {
  id: number;
  ticket: {
    id: number;
    code: string;
    document: string;
    name: string;
  };
  batchCategory: {
    id: number;
    category: {
      name: string;
    };
    modality: {
      name: string;
    };
  };
  price: string;
  cancellationTicket: ICancellationTicket;
}

interface IOrderResponse {
  status: string;
  installments: number;
  event_id: number;
  user_id: number;
  code: string;
  created_at: string;
  name: string;
  total: string;
  discount: string;
  payment: {
    id: number;
    payment_type: string;
    installment: number;
  };
  user: {
    additionalInformation: {
      document: string;
    };
  };
  event: {
    name: string;
    contract: {
      monthly_tax: string;
      service_type: string;
      service: string;
      tax_type: string;
      tax: string;
    };
    free: boolean;
  };
  items: IItem[];
  voucher?: {
    price?: number;
    percent?: number;
  };
}

interface ICancellationTicket {
  id: number;
  cancellation_id: number;
  order_item_id: number;
  ticket_id: number;
  batch_category_id: number;
  price: string;
  item: IItem;
}

interface ICancellationData {
  id: number;
  request_date: string;
  type: number;
  quantity: number;
  request: string;
  value: string;
  discount: string;
  organizer: string;
  status: string;
  payment_date: string;
  order: string;
  event: {
    code: string;
    name: string;
  };
  orderData: {
    code: string;
    total: string;
    created_at: string;
    user: {
      name: string;
      additionalInformation: {
        document: string;
      };
    };
    items: {
      id: string;
    }[];
  };
  cancellationsTickets: ICancellationTicket[];
  archive: {
    archive_url: string;
  };
}

interface ICancellationsResponse {
  data: ICancellationData[];
  from: number;
  to: number;
  total: number;
  pages: number;
}

const Cancels: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [pageSelected, setPageSelected] = useState(1);
  const [tableData, setTableData] = useState({
    from: 0,
    to: 0,
    total: 0,
    totalPage: 0,
    generalTotal: 0,
  });
  const [data, setData] = useState<ICancellation[]>([]);
  const [loading, setLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [proof, setProof] = useState('');
  const [proofName, setProofName] = useState('');
  const [showOrderCancel, setShowOrderCancel] = useState(false);
  const [newCancel, setNewCancel] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [totalWithTax, setTotalWithTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalValueWithDiscount, setTotalValueWithDiscount] = useState(0);
  const [totalWithTaxAndDiscount, setTotalWithTaxAndDiscount] = useState(0);
  const [checkTotal, setCheckTotal] = useState('Total');
  const [cancelattion, setCancelattion] = useState({} as ICancellation);
  const [buyerName, setBuyerName] = useState<string | undefined>(undefined);
  const [eventName, setEventName] = useState<string | undefined>(undefined);
  const [order, setOrder] = useState<string | undefined>(undefined);
  const [startDate, setStartDate] = useState<string | undefined>(undefined);
  const [endDate, setEndDate] = useState<string | undefined>(undefined);
  const [quantity, setQuantity] = useState(10);
  const [serviceTaxType, setServiceTaxType] = useState('Porcentagem');
  const [serviceTax, setServiceTax] = useState(0);
  const [processingTaxType, setProcessingTaxType] = useState('Porcentagem');
  const [processingTax, setProcessingTax] = useState(0);
  const [installment, setInstallment] = useState(0);
  const [monthlyTax, setMonthlyTax] = useState(0);
  const [orderCanceled, setOrderCanceled] = useState(false);
  const [isFree, setIsFree] = useState(false);
  const [orderError, setOrderError] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [discountPay, setDiscountPay] = useState(0);
  const [totalPay, setTotalPay] = useState(0);
  const [isDiscount100Percent, setIsDiscount100Percent] = useState(false);

  useEffect(() => {
    if (Object.keys(cancelattion).length > 0 && cancelattion.tickets) {
      const subTotal = cancelattion.tickets.reduce((previous, current) => {
        if (current.canceled && !showEdit) {
          return previous;
        }
        return previous + (current.isChecked ? current.value : 0);
      }, 0);
      const discount = cancelattion.tickets.reduce((previous, current) => {
        if (current.canceled && !showEdit) {
          return previous;
        }
        return previous + (current.isChecked ? current.discount : 0);
      }, 0);

      let serviceFee = 0;
      let processingFee = 0;

      if (serviceTaxType === 'Porcentagem') {
        serviceFee = subTotal * (serviceTax / 100);
      } else {
        serviceFee = serviceTax;
      }
      if (processingTaxType === 'Porcentagem') {
        processingFee = subTotal * (processingTax / 100);
      } else {
        processingFee = processingTax;
      }

      let total = subTotal + serviceFee + processingFee;

      if (installment > 1) {
        const installmentValue =
          (total * monthlyTax) / (1 - (1 + monthlyTax) ** -installment);

        total = parseFloat((installmentValue * installment).toFixed(2));
      }

      setTotalValue(subTotal);
      setTotalWithTax(total);
      setTotalDiscount(discount);
      setTotalValueWithDiscount(subTotal > 0 ? subTotal - discount : subTotal);
      setTotalWithTaxAndDiscount(total > 0 ? total - discount : total);

      if (discount > 0 && installment > 1) {
        total = subTotal + serviceFee + processingFee - discount;
        const installmentValue =
          (total * monthlyTax) / (1 - (1 + monthlyTax) ** -installment);

        total = parseFloat((installmentValue * installment).toFixed(2));
        setTotalWithTax(total + discount);
        setTotalWithTaxAndDiscount(total);
      }
    }
  }, [
    cancelattion,
    installment,
    monthlyTax,
    processingTax,
    processingTaxType,
    serviceTax,
    serviceTaxType,
    showEdit,
  ]);

  const handleLoadCancels = useCallback(
    async (
      page: number,
      buyer_name?: string,
      event?: string,
      orderData?: string,
      dateStart?: string,
      dateEnd?: string,
      quantityData?: number
    ) => {
      setLoading(true);
      const response = await api.get<ICancellationsResponse>(
        `cancellations/organizers`,
        {
          params: {
            page,
            buyer_name,
            event,
            order: orderData,
            startDate: dateStart ? new Date(dateStart) : undefined,
            endDate: dateEnd ? new Date(dateEnd) : undefined,
            quantity: quantityData,
          },
        }
      );

      const cancellationData = response.data.data.map<ICancellation>(
        (cancellation) => {
          const tickets = cancellation.cancellationsTickets.map<ITicket>(
            (cancellationTicket) => ({
              id: cancellationTicket.item.ticket.id,
              item_id: cancellationTicket.order_item_id,
              batchCategory_id: cancellationTicket.batch_category_id,
              number: cancellationTicket.item.ticket.code,
              value: parseFloat(cancellationTicket.price),
              name: cancellationTicket.item.ticket.name || '-',
              document: cancellationTicket.item.ticket.document || '-',
              modality: cancellationTicket.item.batchCategory.modality.name,
              category: cancellationTicket.item.batchCategory.category.name,
              isChecked: true,
              canceled: true,
              discount: cancellation.discount
                ? parseFloat(cancellation.discount) /
                  cancellation.cancellationsTickets.length
                : 0,
            })
          );
          return {
            id: cancellation.id,
            request_id: cancellation.id.toString(),
            request_date: format(
              parseISO(cancellation.request_date),
              'dd/MM/yyyy'
            ),
            request_type: cancellation.type === 1 ? 'Total' : 'Parcial',
            event: cancellation.event.name,
            buyer_name: cancellation.orderData.user.name,
            buyer_cpf:
              cancellation.orderData.user.additionalInformation.document,
            buy_date: format(
              parseISO(cancellation.orderData.created_at),
              'dd/MM/yyyy'
            ),
            order_number: cancellation.orderData.code,
            ticket_quantity: cancellation.orderData.items.length.toString(),
            order_value: formatPrice(parseFloat(cancellation.order)),
            cancel_quantity: cancellation.quantity.toString(),
            cancel_value: formatPrice(parseFloat(cancellation.value)),
            payment_status: cancellation.status,
            execution_date: cancellation.payment_date
              ? format(parseISO(cancellation.payment_date), 'dd/MM/yyyy')
              : '-',
            tax_value: cancellation.organizer
              ? formatPrice(parseFloat(cancellation.organizer))
              : '-',
            tickets,
            file: cancellation.archive?.archive_url,
          };
        }
      );

      setData(cancellationData);

      setTableData((oldState) => ({
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
        totalPage: response.data.pages,
        generalTotal: oldState.generalTotal
          ? oldState.generalTotal
          : response.data.total,
      }));
      setLoading(false);
    },
    []
  );

  useEffect(() => {
    handleLoadCancels(1);
  }, [handleLoadCancels]);

  const handleNewCancel = useCallback(() => {
    setShowOrderCancel(true);
    setNewCancel(true);
  }, []);

  const handleClickView = useCallback((row) => {
    setShowView(true);
    setProof(row.file);
    setProofName(row.file_name ?? '');
  }, []);

  const handleClickViewRequest = useCallback(async (row: ICancellation) => {
    const orderId = parseInt(row.order_number.slice(12), 10);
    const response = await api.get<IOrderResponse>(`orders/${orderId}`);

    setMonthlyTax(parseFloat(response.data.event.contract.monthly_tax));
    setServiceTaxType(response.data.event.contract.service_type);
    setServiceTax(parseFloat(response.data.event.contract.service));
    setProcessingTaxType(response.data.event.contract.tax_type);
    setProcessingTax(parseFloat(response.data.event.contract.tax));
    setInstallment(response.data.installments);
    setIsDiscount100Percent(response.data.discount === response.data.total);

    const tickets = response.data.items.map<ITicket>((item) => ({
      id: item.ticket.id,
      item_id: item.id,
      batchCategory_id: item.batchCategory.id,
      number: item.ticket.code,
      name: item.ticket.name || '-',
      document: item.ticket.document || '-',
      category: item.batchCategory.category.name,
      modality: item.batchCategory.modality.name,
      value: parseFloat(item.price),
      discount: response.data.discount
        ? parseFloat(response.data.discount) / response.data.items.length
        : 0,
      isChecked:
        row.request_type === 'Total' ||
        row.tickets.some((ticket) => ticket.id === item.ticket.id),
      canceled: !!(
        item.cancellationTicket &&
        Object.keys(item.cancellationTicket).length > 0
      ),
    }));

    setCheckTotal(row.request_type as string);

    setCancelattion({
      ...row,
      order_date: row.buy_date,
      tickets,
    });
    setShowOrderCancel(true);
    setShowEdit(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowView(false);
    setShowOrderCancel(false);
    setShowEdit(false);
    setCheckTotal('');
    setTotalValue(0);
    setTotalWithTax(0);
    setNewCancel(false);
    setCancelattion({} as ICancellation);
    setMonthlyTax(0);
    setServiceTaxType('Porcentagem');
    setServiceTax(0);
    setProcessingTaxType('Porcentagem');
    setProcessingTax(0);
    setInstallment(0);
    setOrderCanceled(false);
  }, []);

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          order_number: Yup.string()
            .required('O número pedido é obrigatório')
            .test('check-error', 'Pedido não encontrado', () => {
              return !orderError;
            }),
          request_type: Yup.string().required(
            'O tipo de cancelamento é obrigatório'
          ),
          cancel_value: Yup.string()
            .test(
              'is-positive',
              'Valor do cancelamento maior que o disponível',
              async (value) => {
                if (value) {
                  const response = await api.get('cash-flows/organizer');
                  const cashFlows = response.data.reverse();

                  return (
                    parseFloat(
                      value
                        .replace('R$', '')
                        .replaceAll('.', '')
                        .replace(',', '.')
                    ) <= parseFloat(cashFlows[0].balance) || true
                  );
                }
                return true;
              }
            )
            .test(
              'is-positive',
              'Valor do cancelamento não pode ser zerado',
              async (value) => {
                if (value) {
                  return (
                    parseFloat(
                      value
                        .replace('R$', '')
                        .replaceAll('.', '')
                        .replace(',', '.')
                    ) > 0 ||
                    isFree ||
                    paymentStatus === 'Cortesia' ||
                    discountPay === totalPay
                  );
                }
                return false;
              }
            )
            .required('O valor do cancelamento é obrigatório'),
        });

        await schema.validate(formData, {
          abortEarly: false,
        });

        const newCancelationTickets = cancelattion.tickets.filter(
          (ticket) => !ticket.canceled
        );

        const tickets = newCancelationTickets.filter(
          (ticket) => ticket.isChecked
        );

        const quantityCancelled = tickets.length;

        const cancellationFormData = {
          event_id: cancelattion.event_id,
          payment_id: cancelattion.payment_id,
          order_id: cancelattion.order_id,
          user_id: cancelattion.user_id,
          type: formData.request_type === 'Total' ? 1 : 2,
          quantity: quantityCancelled,
          order: totalValueWithDiscount,
          value: parseFloat(
            formData.cancel_value
              .replace('R$', '')
              .replaceAll('.', '')
              .replace(',', '.')
          ),
          // organizer: Joi.number().allow('', null).empty().optional(),
        };

        const response = await api.post(
          'cancellations/organizers',
          cancellationFormData
        );

        if (tickets.length > 0) {
          for (const ticket of tickets) {
            const cancelTicketFormData = {
              cancellation_id: response.data.id,
              order_item_id: ticket.item_id,
              ticket_id: ticket.id,
              batch_category_id: ticket.batchCategory_id,
              price: ticket.value,
            };

            await api.post(
              'cancellations-tickets/organizers',
              cancelTicketFormData
            );
          }
        }

        setData((oldData: ICancellation[]) => {
          return [
            {
              id: response.data.id,
              request_id: response.data.id.toString(),
              request_date: format(
                parseISO(response.data.created_at),
                'dd/MM/yyyy'
              ),
              request_type: checkTotal,
              event: cancelattion.event,
              buyer_name: cancelattion.buyer_name,
              buyer_cpf: cancelattion.buyer_cpf,
              buy_date: cancelattion.buy_date,
              order_number: cancelattion.order_number,
              ticket_quantity: cancelattion.ticket_quantity,
              order_value: formatPrice(totalValueWithDiscount),
              cancel_quantity: quantityCancelled.toString(),
              cancel_value: formData.cancel_value,
              payment_status: 'Aguardando Cancelamento',
              execution_date: '-',
              tax_value: '-',
              file: '',
              tickets: cancelattion.tickets,
            },
            ...oldData,
          ];
        });
        setLoading(false);
        handleClose();
      } catch (error) {
        setLoading(false);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro!');
        }
      }
    },
    [
      cancelattion.buy_date,
      cancelattion.buyer_cpf,
      cancelattion.buyer_name,
      cancelattion.event,
      cancelattion.event_id,
      cancelattion.order_id,
      cancelattion.order_number,
      cancelattion.payment_id,
      cancelattion.ticket_quantity,
      cancelattion.tickets,
      cancelattion.user_id,
      checkTotal,
      discountPay,
      handleClose,
      isFree,
      orderError,
      paymentStatus,
      totalPay,
      totalValueWithDiscount,
    ]
  );

  const handleDeleteRow = useCallback(
    (row) => {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: `Gostaria de excluir o cancelamento?`,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (e) => {
        if (e.isConfirmed) {
          await api.delete(`cancellations/organizers/${row.id}`);
          setData(data.filter((item) => item.id !== row.id));
          handleClose();
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Cancelamento excluído com sucesso!',
          });
        }
      });
    },
    [data, handleClose]
  );

  const columns = useMemo<IColumn[]>(
    () => [
      {
        name: 'ID Solicitação',
        selector: 'request_id',
        sortable: true,
      },

      {
        name: 'Dt Solicitação',
        selector: 'request_date',
        sortable: true,
      },
      {
        name: 'Tipo Solicitação',
        selector: 'request_type',
        sortable: true,
      },

      {
        name: 'Evento',
        selector: 'event',
        sortable: true,
      },
      {
        name: 'Status',
        selector: 'payment_status',
        sortable: true,
        cell: (row) => (
          <Status
            status={row.payment_status}
            className="text-white rounded-pill mb-0"
          >
            {row.payment_status}
          </Status>
        ),
      },
      {
        name: 'Nome Comprador',
        selector: 'buyer_name',
        sortable: true,
      },
      {
        name: 'Dt Compra',
        selector: 'buy_date',
        sortable: true,
      },
      {
        name: 'Nro Pedido',
        selector: 'order_number',
        sortable: true,
      },
      {
        name: 'Valor Pedido',
        selector: 'order_value',
        sortable: true,
      },
      {
        name: 'Inscrições',
        selector: 'ticket_quantity',
        sortable: true,
      },
      {
        name: 'Cancelados',
        selector: 'cancel_quantity',
        sortable: true,
      },
      {
        name: 'Valor Cancelado',
        selector: 'cancel_value',
        sortable: true,
      },

      {
        name: 'Dt execução',
        selector: 'execution_date',
        sortable: true,
      },
      {
        name: 'Valor Reembolso',
        selector: 'tax_value',
        sortable: true,
      },
      {
        name: '',
        selector: 'active',
        sortable: false,
        cell: (row: ICancellation) => (
          <>
            <button
              type="button"
              onClick={() => handleClickViewRequest(row)}
              className={` btn-icons border-0 me-2`}
            >
              <KrEye size={16} color="#fff" />
            </button>
            <button
              type="button"
              onClick={() => handleClickView(row)}
              disabled={!row.file}
              className={`${
                !row.file ? 'pe-none opacity-50' : ''
              } btn-icons border-0 me-2`}
            >
              <KrEye size={16} color="#fff" />
            </button>
            <button
              type="button"
              disabled={row.payment_status === 'Pago'}
              onClick={() => handleDeleteRow(row)}
              className={` btn-icons border-0 me-2`}
            >
              <KrClose size={16} color="#fff" />
            </button>
          </>
        ),
      },
    ],
    [handleClickView, handleClickViewRequest, handleDeleteRow]
  );

  const handleChangeOrderNumber = useCallback(async (e) => {
    const { value } = e.target;
    setOrderError('');

    if (value.length > 16) {
      try {
        const orderId = parseInt(value.slice(12), 10);
        const response = await api.get<IOrderResponse>(
          `orders/organizers/${orderId}`
        );

        setMonthlyTax(parseFloat(response.data.event.contract.monthly_tax));
        setServiceTaxType(response.data.event.contract.service_type);
        setServiceTax(parseFloat(response.data.event.contract.service));
        setProcessingTaxType(response.data.event.contract.tax_type);
        setProcessingTax(parseFloat(response.data.event.contract.tax));
        setInstallment(response.data.installments);
        setOrderCanceled(
          response.data.items.every(
            (item) =>
              !!(
                item.cancellationTicket &&
                Object.keys(item.cancellationTicket).length > 0
              )
          )
        );

        setIsFree(response.data.event.free);
        setIsDiscount100Percent(response.data.discount === response.data.total);

        setPaymentStatus(response.data.status);
        setDiscountPay(parseFloat(response.data.total));
        setTotalPay(parseFloat(response.data.total));

        setCancelattion((oldState) => ({
          ...oldState,
          event_id: response.data.event_id,
          payment_id: response.data?.payment?.id,
          order_id: orderId,
          user_id: response.data.user_id,
          order_value: formatPrice(parseFloat(response.data.total)),
          order_date: format(parseISO(response.data.created_at), 'dd/MM/yyyy'),
          ticket_quantity: response.data.items.length.toString(),
          order_number: response.data.code,
          buyer_name: response.data.name,
          buyer_cpf: response.data.user.additionalInformation.document,
          event: response.data.event.name,
          buy_date: format(parseISO(response.data.created_at), 'dd/MM/yyyy'),
          tickets: response.data.items.map<ITicket>((item) => {
            let discount = 0;
            if (response.data.voucher) {
              if (response.data.voucher.price) {
                discount =
                  parseFloat(response.data.discount) /
                  response.data.items.length;
              }

              if (response.data.voucher.percent) {
                discount =
                  (parseFloat(item.price) / 100) *
                  response.data.voucher.percent;
              }
            }
            return {
              id: item.ticket.id,
              item_id: item.id,
              batchCategory_id: item.batchCategory.id,
              number: item.ticket.code,
              name: item.ticket.name || '-',
              document: item.ticket.document || '-',
              category: item.batchCategory.category.name,
              modality: item.batchCategory.modality.name,
              value: parseFloat(item.price),
              isChecked: true,
              canceled: !!(
                item.cancellationTicket &&
                Object.keys(item.cancellationTicket).length > 0
              ),
              discount,
            };
          }),
        }));
      } catch (error) {
        const err = error as AxiosError;
        if (err.response?.data.message === 'Order não encontrado') {
          setCancelattion((oldState) => ({
            ...oldState,
            order_number: value,
          }));
          setOrderError('Pedido não encontrado');
        }
      }
    } else {
      setCancelattion((oldState) => ({
        ...oldState,
        order_number: value,
      }));
    }
  }, []);

  const handleSelectTicket = useCallback(
    (ticketId: number) => {
      const newTickets = cancelattion.tickets.map((ticket) => {
        if (ticket.id === ticketId) {
          return {
            ...ticket,
            isChecked: !ticket.isChecked,
          };
        }
        return ticket;
      });

      setCancelattion((oldState) => ({
        ...oldState,
        tickets: newTickets,
      }));
    },
    [cancelattion.tickets]
  );

  const handleChangeCheckTotal = useCallback(
    (type) => {
      if (type === 'Total') {
        const newTickets = cancelattion.tickets.map((ticket) => ({
          ...ticket,
          isChecked: true,
        }));
        setCancelattion((oldState) => ({
          ...oldState,
          tickets: newTickets,
        }));
        setCheckTotal('Total');
      } else {
        const newTickets = cancelattion.tickets.map((ticket) => ({
          ...ticket,
          isChecked: !!ticket.canceled,
        }));
        setCancelattion((oldState) => ({
          ...oldState,
          tickets: newTickets,
        }));
        setCheckTotal('Parcial');
      }
    },
    [cancelattion.tickets]
  );

  const handleChangePage = useCallback(
    (page) => {
      if (page <= tableData.totalPage) {
        handleLoadCancels(
          page,
          buyerName,
          eventName,
          order,
          startDate,
          endDate,
          quantity
        );
        setPageSelected(page);
      }
    },
    [
      buyerName,
      endDate,
      eventName,
      handleLoadCancels,
      order,
      quantity,
      startDate,
      tableData.totalPage,
    ]
  );

  const handleSubmitFilters = useCallback(
    (formData) => {
      setBuyerName(formData.name);
      setEventName(formData.event === 'Todos' ? undefined : formData.event);
      setOrder(formData.order);
      setStartDate(formData.dateStart);
      setEndDate(formData.dateEnd);
      handleLoadCancels(
        1,
        formData.name,
        formData.event === 'Todos' ? undefined : formData.event,
        formData.order,
        formData.dateStart,
        formData.dateEnd,
        quantity
      );
      setPageSelected(1);
    },
    [handleLoadCancels, quantity]
  );

  const handleChangeQuantity = useCallback(
    (quantityData) => {
      handleLoadCancels(
        1,
        buyerName,
        eventName,
        order,
        startDate,
        endDate,
        quantityData
      );
      setQuantity(quantityData);
      setPageSelected(1);
    },
    [buyerName, endDate, eventName, handleLoadCancels, order, startDate]
  );

  return (
    <Container>
      <div className="container-fluid">
        <div className="row">
          <div className="zoom col-12 px-0">
            <div className="bg-white d-sm-flex justify-content-between align-items-center p-4">
              <h1 className="mb-0">Cancelamentos</h1>
              <button
                type="button"
                onClick={handleNewCancel}
                className="mb-0 me-4 h6 fw-normal text-white btn-new px-3 py-2"
              >
                <HiPlus size={16} color="#fff" className="me-2" />
                Novo cancelamento
              </button>
            </div>
          </div>
          <Filter className="col-12 px-0 mt-3">
            <FiltersLists
              onSubmitFilters={handleSubmitFilters}
              event
              order
              name
              nameUser
              date
            />
          </Filter>
          <div className="col-12 px-0">
            <div className="row">
              <TableList className="col-12 mt-3">
                <div className="bg-white pb-2">
                  <div className="bg-white overflow-auto">
                    <div className="">
                      <Table
                        className="mb-0 p-0 table"
                        columns={columns}
                        data={data}
                        pagination
                        changeQuantity
                        showTotals
                        generalTotal={tableData.generalTotal}
                        totalData={tableData.total}
                        selectedPage={pageSelected}
                        onChangePage={handleChangePage}
                        onChangeQuantity={handleChangeQuantity}
                      />
                    </div>
                  </div>
                </div>
              </TableList>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={showView}
        onHide={handleClose}
      >
        <Modal.Header className="position-relative justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
          <Modal.Title className="mb-0 mt-4">
            <h2 className="title mb-0">Comprovante</h2>
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="border-0 bg-transparent"
          >
            <KrClose size={20} color="#989898" />
          </button>
        </Modal.Header>
        <Modal.Body className="pt-0 px-3 px-sm-5">
          <div className="row">
            <div className="col-12">
              <hr />
            </div>
            <div className="col-12">
              {proofName.toLowerCase().includes('.pdf') ||
              proof.toLowerCase().includes('.pdf') ? (
                <iframe
                  className="w-100"
                  height={500}
                  title="Comprovante"
                  src={proof}
                  frameBorder="0"
                />
              ) : (
                <img className="w-100 mb-5" src={proof} alt={proof} />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={showOrderCancel}
        onHide={handleClose}
      >
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Solicitação cancelamento</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={handleClose}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12">
                <hr />
              </div>
              <div className="col-6">
                <label
                  className={`${
                    showEdit ? 'pe-none' : ''
                  } position-relative d-block mt-3`}
                >
                  <span className="h6 d-block fw-normal">Número do pedido</span>
                  <Input
                    name="order_number"
                    type="number"
                    className="input"
                    value={cancelattion.order_number}
                    onChange={handleChangeOrderNumber}
                    error={orderCanceled ? 'Pedido já cancelado' : orderError}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Data do pedido</span>
                  <Input
                    name="order_date"
                    className="input"
                    value={cancelattion.order_date}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Comprador</span>
                  <Input
                    name="buyer_name"
                    className="input"
                    value={cancelattion.buyer_name}
                  />
                </label>
              </div>
              <div className="col-6">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">CPF</span>
                  <InputMask
                    className="input mt-2"
                    kind="cpf"
                    name="buyer_cpf"
                    value={cancelattion.buyer_cpf}
                  />
                </label>
              </div>
              <div className="col-12">
                <label className="pe-none d-block mt-3">
                  <span className="h6 d-block fw-normal">Evento</span>
                  <Input
                    name="event"
                    className="input"
                    value={cancelattion.event}
                  />
                </label>
              </div>
              <div className="col-6">
                <label
                  className={`${
                    showEdit || orderCanceled ? 'pe-none' : ''
                  } position-relative d-block mt-3`}
                >
                  <span className="h6 d-block fw-normal">
                    Tipo de Cancelamento
                  </span>
                  <div className="d-flex mt-3">
                    <button
                      type="button"
                      onClick={() => handleChangeCheckTotal('Total')}
                      className="d-flex align-items-center check border-0 bg-transparent me-4"
                    >
                      <span
                        className={`${
                          checkTotal === 'Total' ? 'checked' : ''
                        } me-2`}
                      >
                        {checkTotal === 'Total' && (
                          <HiCheck
                            size={16}
                            color="#fff"
                            className="check-icon"
                          />
                        )}
                      </span>
                      Total
                    </button>
                    <button
                      type="button"
                      onClick={() => handleChangeCheckTotal('Parcial')}
                      className="d-flex align-items-center check border-0 bg-transparent"
                    >
                      <span
                        className={`${
                          checkTotal === 'Parcial' ? 'checked' : ''
                        } me-2`}
                      >
                        {checkTotal === 'Parcial' && (
                          <HiCheck
                            size={16}
                            color="#fff"
                            className="check-icon"
                          />
                        )}
                      </span>
                      Parcial
                    </button>
                    <Input
                      name="request_type"
                      className="d-none"
                      value={checkTotal}
                    />
                  </div>
                </label>
              </div>
              <div className="col-6">
                <label
                  className={`${
                    showEdit || orderCanceled ? 'pe-none' : ''
                  } position-relative d-block mt-3`}
                >
                  <span className="h6 d-block fw-normal">
                    Valor do Cancelamento
                  </span>
                  <InputMask
                    className="input mt-2"
                    kind="money"
                    placeholder="R$"
                    name="cancel_value"
                    value={cancelattion.cancel_value}
                  />
                </label>
              </div>
              <div className={`${showEdit ? 'pe-none' : ''} col-12 mt-3`}>
                <span className="h6 d-block fw-normal">Inscrições</span>
                <div className="t-container">
                  <div className="t-header d-flex p-2">
                    <span>Número</span>
                    <span>Modalidade - Categoria</span>
                    <span>Nome</span>
                    <span>CPF</span>
                    <span>Valor unitário</span>
                  </div>
                  <div className="t-body py-3">
                    {cancelattion.tickets?.map((ticket) => (
                      <div
                        className={`d-flex align-items-center py-1 ${
                          ticket.canceled ? 'opacity-50' : ''
                        }`}
                      >
                        <span className="d-flex justify-content-start align-items-center px-2">
                          <button
                            type="button"
                            className="d-flex align-items-center check border-0 bg-transparent"
                            onClick={() => handleSelectTicket(ticket.id)}
                            disabled={ticket.canceled || checkTotal === 'Total'}
                          >
                            <span
                              className={`${
                                ticket.isChecked ? 'checked' : ''
                              } check-list me-2 d-flex justify-content-center align-items-center`}
                            >
                              <HiCheck
                                size={13}
                                color="#fff"
                                className="check-icon"
                              />
                            </span>
                          </button>
                          {ticket.number}
                          {ticket.canceled ? ' (Devolvido)' : ''}
                        </span>

                        <span className="px-2">
                          {ticket.modality} - {ticket.category}
                        </span>
                        <span className="px-2">{ticket.name}</span>
                        <span className="px-2">{ticket.document}</span>
                        <span className="px-2">
                          {formatPrice(ticket.value)}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="t-footer py-2 px-4">
                    <div className="d-flex justify-content-between">
                      <span>Total</span>
                      <span className="total">{formatPrice(totalValue)}</span>
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between">
                      <span>Total com as taxas</span>
                      <span className="total">{formatPrice(totalWithTax)}</span>
                    </div>
                    {totalDiscount > 0 && (
                      <>
                        <hr className="my-2" />
                        <div className="d-flex justify-content-between">
                          <span>Valor de desconto</span>
                          <span className="total">
                            {isDiscount100Percent
                              ? formatPrice(totalWithTax)
                              : formatPrice(totalDiscount)}
                          </span>
                        </div>

                        <hr className="my-2" />
                        <div className="d-flex justify-content-between">
                          <span>Total com as taxas e desconto</span>
                          <span className="total">
                            {isDiscount100Percent
                              ? formatPrice(0)
                              : formatPrice(totalWithTaxAndDiscount)}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button
              type={newCancel ? 'submit' : 'button'}
              onClick={() => {
                if (!newCancel) {
                  handleClose();
                }
              }}
              className="ms-auto btn-filter d-flex align-items-center justify-content-center btn h6 fw-normal py-2 px-4 mt-2 mb-0"
              disabled={
                newCancel
                  ? orderCanceled ||
                    (Object.keys(cancelattion).length > 3 &&
                      !cancelattion.tickets.some(
                        (ticket) => !ticket.canceled && ticket.isChecked
                      ))
                  : undefined
              }
            >
              {newCancel ? 'Salvar' : 'Fechar'}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Loading active={loading} text="Carregando..." />
    </Container>
  );
};

export default Cancels;
